import { useCompanyProfile } from '@/account';
import { computed } from 'vue';
import {
	PhoneSystemItemName,
	ProductAlias,
	SubscriptionName,
	SubscriptionStatus
} from '../types';
import { useBilling } from '..';

export function usePhoneSystem() {
	const state = useBilling();
	const { isPaidAccount } = useCompanyProfile();

	const phoneSystemSubscription = computed(() =>
		state.currentSubscription.value?.items.find(
			(sub) =>
				sub.productAlias ===
				ProductAlias.phoneNumbers
		)
	);

	return {
		phoneSystemSubscription,
		hasPhoneSystem: computed(() => {
			return (
				!isPaidAccount.value ||
				!!phoneSystemSubscription.value
			);
		}),
		isPhoneSystemActive: computed(() => {
			return (
				!isPaidAccount.value ||
				state.currentSubscription.value
					?.stripe_status ===
					SubscriptionStatus.active
			);
		}),
		totalAvailablePhoneNumbers: computed(
			() =>
				phoneSystemSubscription.value?.quantity || 0
		)
	};
}
